import { axiosAssessmentInstance } from "../AxiosConfiguration";

const getTimePeriod = (timezone) => {
  const resolvedTimezone = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  let hour = new Date().getHours();

  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: resolvedTimezone,
      hour: "2-digit",
      hour12: false,
    }).formatToParts(new Date());
    const hourPart = parts.find((p) => p.type === "hour")?.value;
    const parsed = Number(hourPart);
    if (Number.isFinite(parsed)) hour = parsed;
  } catch (_) {
    // Fall back to local time
  }

  // 12:00 AM – 4:59 AM
  if (hour >= 0 && hour < 5) return "HELLO";

  // 5:00 AM – 11:59 AM
  if (hour >= 5 && hour < 12) return "MORNING";

  // 12:00 PM – 5:59 PM
  if (hour >= 12 && hour < 18) return "AFTERNOON";

  // 6:00 PM – 11:59 PM
  return "EVENING";
};

const getFirstNameFromProfile = () => {
  try {
    const profile = JSON.parse(localStorage.getItem("profile") || "null");
    const firstName = profile?.first_name || profile?.firstName;
    return typeof firstName === "string" ? firstName.trim() : "";
  } catch (_) {
    return "";
  }
};

const getStoredWelcomeMessage = (timezone) => {
  try {
    const storedData = localStorage.getItem('welcomeMessage');
    if (!storedData) return null;

    const { message, timestamp, timePeriod, timezone: storedTz } = JSON.parse(storedData);
    const currentTime = new Date().getTime();
    const oneDay = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

    // Check if the message is from today and for the current time period
    const currentPeriod = getTimePeriod(timezone || storedTz);
    if ((currentTime - timestamp) < oneDay && timePeriod === currentPeriod) {
      return { message, timestamp, timePeriod, timezone: storedTz };
    }
    return null;
  } catch (error) {
    console.error("Error reading welcome message from storage:", error);
    return null;
  }
};

const storeWelcomeMessage = (message, timezone) => {
  try {
    const data = {
      message,
      timestamp: new Date().getTime(),
      timePeriod: getTimePeriod(timezone),
      timezone: timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    localStorage.setItem('welcomeMessage', JSON.stringify(data));
  } catch (error) {
    console.error("Error storing welcome message:", error);
  }
};

export const getWelcomeMessage = async (forceRefresh = false) => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Check if we have a valid stored message first
    if (!forceRefresh) {
      const storedMessage = getStoredWelcomeMessage(timezone);
      if (storedMessage) {
        const firstName = getFirstNameFromProfile();
        if (firstName) {
          return `Welcome, ${firstName}.`;
        }
        return storedMessage.message;
      }
    }

    // If no stored message or force refresh, fetch a new one
    const firstName = getFirstNameFromProfile();

    const response = await axiosAssessmentInstance.post("/api/welcome/welcome", {
      name: firstName,
      timezone,
    });

    const message = response?.data?.payload;
    if (message?.message) {
      storeWelcomeMessage(message.message, timezone);
    }

    return message?.message || "Hi, I'm Aris. I'm here to support your journey to health, fulfillment, and joy.";
  } catch (error) {
    console.error("Error during welcome message API call:", error);
    // Return a default message if the API call fails
    return "Hi, I'm Aris. I'm here to support your journey to health, fulfillment, and joy.";
  }
};